import {
  LabelInput,
  EntryTypeSelect,
  RequiredToggle,
  StandardDesignConfig,
  HideOnPdfToggle,
} from 'apps/studio/components/settings/fields/Base/standard'

import { SettingsLabel } from 'apps/studio/components/shared/inputs/SettingsLabel'

const MultipleChoiceStyleSelect = {
  label: 'Style',
  settingType: 'selectInput',
  updateType: 'entry',
  property: 'style',
  choices: [
    {
      label: 'Checkboxes',
      value: 2,
    },
    {
      label: 'Button',
      value: 6,
    },
  ],
}

// no default value or read only, so no hide on form either
export const MultipleChoiceStandardSettings = [
  LabelInput,
  EntryTypeSelect,
  MultipleChoiceStyleSelect,
  SettingsLabel('Config'),
  RequiredToggle,
  ...StandardDesignConfig,
  HideOnPdfToggle,
]
